import ReactDOM from "react-dom";
import "./style/index.css";
import App from "./containers/App/App";
import reportWebVitals from "./reportWebVitals";
import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
